"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaService = void 0;
const api_1 = require("./api");
const PATH = 'media/api';
class MediaService {
    static async getAdvertisements(page, size, sort, filter, isAnnouncements) {
        let requestParams = [`page=${page || 0}`, `size=${size || 9999}`];
        if (sort) {
            requestParams.push(`sort=${sort}`);
        }
        else {
            requestParams.push(`sort=priority,asc`);
            requestParams.push(`sort=createdDate,desc`);
        }
        if (filter && filter.length > 0) {
            requestParams = [...requestParams, ...filter];
        }
        const url = isAnnouncements
            ? `${PATH}/announcements?${requestParams.join('&')}`
            : `${PATH}/advertisements?${requestParams.join('&')}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async getAnnouncements(page, size, sort, filter) {
        return this.getAdvertisements(page, size, sort, filter, true);
    }
    static async getAdvertisement(id) {
        const url = `${PATH}/advertisements/${id}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async getTags() {
        const url = `${PATH}/tags`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
}
exports.MediaService = MediaService;
//# sourceMappingURL=media-service.js.map